// NEW: UI_REVAMP
import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import GradientText from '../../common/GradientText';
import CopyValueButton from '../../common/CopyValueButton';
import {
	RECORD_GRADIENTS,
	RECORD_SHADOWS,
	RECORD_TEXT_COLORS,
} from '../../../styles/recordUiTokens';
import { getRecordStatusStyle } from '../historyStatusStyles';
import useIsMobileView from '../../../hooks/useIsMobileView';

const HistoryTicketInfoCard = ({
	ticketId,
	betDateTime,
	drawDateTime,
	siteType,
	totalBets,
	totalBetAmount,
	totalWins,
	totalWinAmount,
	ticketStatus,
	isExpire,
	ticket,
	serverTime,
}) => {
	const isMobileView = useIsMobileView();
	const valueFontSize = isMobileView ? '14px' : '16px';
	const MoneySize = isMobileView ? '20px' : '22px';
	const moneyTitleFontSize = isMobileView ? '14px' : '16px';

	return (
		<Box
			width='100%'
			padding='1px'
			borderRadius='8px'
			background={RECORD_GRADIENTS.goldBorder}
			boxShadow={RECORD_SHADOWS.goldCard}
		>
			<Box
				background={RECORD_GRADIENTS.detailCardSurface}
				borderRadius='7px'
				padding={{ base: '10px 10px 2px 10px' }}
			>
				<TicketInfoRow
					label='Ticket ID'
					value={ticketId}
					color={RECORD_TEXT_COLORS.link}
					valueFontWeight='600'
					valueIcon={
						<CopyValueButton
							value={ticketId}
							successMessage='Copied Ticket ID'
							ariaLabel='Copy Ticket ID'
							color={RECORD_TEXT_COLORS.link}
						/>
					}
				/>
				<TicketInfoRow
					label='Bet Date Time'
					value={betDateTime}
					valueFontWeight='600'
					valueFontSize={valueFontSize}
				/>
				<TicketInfoRow
					label='Draw Date Time'
					value={drawDateTime}
					valueFontWeight='600'
					valueFontSize={valueFontSize}
				/>
				<TicketInfoRow
					label='Site Type'
					value={siteType}
					valueFontWeight='600'
					valueFontSize={valueFontSize}
				/>
				<TicketInfoRow
					label='Total Bets'
					value={totalBets}
					valueFontWeight='600'
					valueFontSize={valueFontSize}
				/>
				<TicketInfoRow
					label='Total Bet Amount (PHP)'
					value={totalBetAmount}
					isGradientText
					valueFontWeight='700'
					valueFontSize={MoneySize}
					moneyTitleFontSize={moneyTitleFontSize}
				/>
				<TicketInfoRow
					label='Total Wins'
					value={totalWins}
					valueFontWeight='600'
					valueFontSize={valueFontSize}
				/>
				<TicketInfoRow
					label='Total Win Amount (PHP)'
					value={totalWinAmount}
					isGradientText
					valueFontWeight='700'
					valueFontSize={MoneySize}
					moneyTitleFontSize={moneyTitleFontSize}
				/>
				<TicketInfoRow
					label='Ticket Status'
					value={
						<DetailStatusPill
							status={ticketStatus}
							isExpire={isExpire}
							ticket={ticket}
							serverTime={serverTime}
						/>
					}
					valueFontSize={valueFontSize}
					isCustomContent
				/>
			</Box>
		</Box>
	);
};

export default HistoryTicketInfoCard;

const TicketInfoRow = ({
	label,
	value,
	color,
	isCustomContent = false,
	isGradientText = false,
	valueFontWeight = '500',
	moneyTitleFontSize = '16px',
	valueFontSize = '16px',
	valueIcon,
}) => {
	return (
		<Flex justifyContent='space-between' alignItems='center' gap='16px' marginBottom='10px'>
			<Text
				flex='1'
				fontSize={moneyTitleFontSize}
				fontWeight='500'
				lineHeight='100%'
				color={RECORD_TEXT_COLORS.secondary}
				minWidth='0'
			>
				{label}
			</Text>
			{isCustomContent ? (
				<Box display='flex' justifyContent='flex-end' flex='1' minWidth='0'>
					{value}
				</Box>
			) : (
				<Box display='flex' justifyContent='flex-end' flex='1' minWidth='0'>
					{isGradientText ? (
						<GradientText
							fontSize={valueFontSize}
							fontWeight={valueFontWeight}
							lineHeight='100%'
							textAlign='right'
							minWidth='0'
						>
							{value}
						</GradientText>
					) : (
						<Flex alignItems='center' justifyContent='flex-end' gap='8px' minWidth='0'>
							{valueIcon ? <Box flexShrink={0}>{valueIcon}</Box> : null}
							<Text
								flex='1'
								fontSize={valueFontSize}
								fontWeight={valueFontWeight}
								lineHeight='100%'
								color={color || RECORD_TEXT_COLORS.primary}
								textAlign='right'
								minWidth='0'
							>
								{value}
							</Text>
						</Flex>
					)}
				</Box>
			)}
		</Flex>
	);
};

const DetailStatusPill = ({ status, isExpire, ticket, serverTime }) => {
	const styles = getRecordStatusStyle(status, { isExpire, variant: 'detail', ticket, serverTime });

	return (
		<Flex
			alignItems='center'
			justifyContent='center'
			minWidth='75px'
			height='27px'
			padding='4px 12px'
			borderRadius='100px'
			fontSize='14px'
			fontWeight='600'
			lineHeight='100%'
			background={styles.background}
			color={styles.color}
		>
			{styles.label}
		</Flex>
	);
};
